import {Component, inject, OnInit} from '@angular/core';
import {NZ_MODAL_DATA, NzModalRef} from "ng-zorro-antd/modal";
import {FormGroup} from "@angular/forms";
import {autoFitColumns, ItemMode, StickerStatus} from "../../shared/shared.service";
import {ProxyDynamicService} from "../../shared/service/proxy-dynamic.service";
import {TranslateService} from "@ngx-translate/core";
import * as XLSX from "xlsx";
import moment from "moment";

@Component({
  selector: 'app-modal-view',
  templateUrl: './modal-view.component.html',
  styleUrl: './modal-view.component.scss'
})
export class ModalViewComponent implements OnInit {
  readonly nzModalData = inject(NZ_MODAL_DATA);
  listStickerStatus: any[] = [];
  listStickerType: any[] = [];
  data!: any;
  itemMode = ItemMode;

  ngOnInit() {
  }

  constructor(
    private modalRef: NzModalRef
  ) {
    this.data = this.nzModalData.data;
    this.listStickerStatus = this.nzModalData.listStickerStatus;
    this.listStickerType = this.nzModalData.listStickerType;
  }

  destroyModal() {
    this.modalRef.destroy();
  }
}
